import { useQuery } from '@tanstack/react-query';

import Api from '@app/services/api';

export const useCounterpartyInvitationQuery = (uid: string) => {
  return useQuery({
    queryKey: ['counterpartyInvitation', uid],
    queryFn: () => Api.users.getCounterpartyInvitation(uid),
    enabled: !!uid,
  });
};
